//#region src/v2/features/localization/locales/ru.ts
/** Built-in API Client translations for ru. */
var ru = {
	"serverVariablesSelect": { "selected": "Выбрано:" },
	"serverVariablesTextbox": { "value": "значение" },
	"sidebarListElementForm": { "cancel": "Отмена" },
	"requestBlock": {
		"authentication": "Аутентификация",
		"variables": "Переменные",
		"cookies": "Cookie",
		"headers": "Заголовки",
		"queryParameters": "Параметры запроса",
		"queryString": "Строка запроса",
		"queryStringDescription": "Этот параметр задаёт всю строку запроса, поэтому добавить другие именованные параметры нельзя. Существующие именованные параметры отправляются после него; повторяющиеся ключи сохраняются.",
		"requestBody": "Тело запроса",
		"requestName": "Название запроса",
		"label": "Запрос: {name}"
	},
	"responseBlock": {
		"requestFailed": "Ошибка запроса",
		"networkErrorHelp": "Возможные причины включают ограничения CORS или проблемы с сетевым подключением. Подробности доступны в консоли браузера. Если CORS блокирует запрос, настройте сервер API, чтобы разрешить этот источник, или используйте доверенный прокси-сервер.",
		"response": "Ответ",
		"requestHeaders": "Заголовки запроса",
		"responseHeaders": "Заголовки ответа",
		"body": "Тело"
	},
	"codeInput": {
		"required": "Обязательно",
		"exitHint": "Нажмите {escape}, затем {tab}, чтобы выйти"
	},
	"codeInputLite": { "required": "Обязательно" },
	"dataTableInput": {
		"clearValue": "Очистить значение",
		"resetValue": "Восстановить значение по умолчанию",
		"showPassword": "Показать пароль",
		"hidePassword": "Скрыть пароль"
	},
	"dataTableInputSelect": {
		"value": "Значение",
		"addValue": "Добавить значение"
	},
	"confirmationForm": {
		"cancel": "Отмена",
		"save": "Сохранить"
	},
	"collapsibleSection": {
		"collapsed": "(Свёрнуто)",
		"item": "Элемент",
		"items": "Элементы"
	},
	"modalClientContainer": { "label": "API-клиент" },
	"serverDropdown": {
		"server": "Сервер:",
		"addServer": "Добавить сервер",
		"updateServers": "Обновить серверы",
		"unknownServer": "Неизвестный сервер"
	},
	"sidebar": { "search": "Поиск" },
	"sidebarMenu": { "settings": "Настройки" },
	"sidebarToggle": {
		"hide": "Скрыть боковую панель",
		"show": "Показать боковую панель"
	},
	"environmentsList": { "addEnvironment": "Добавить окружение" },
	"modal": { "noDocumentSelected": "Документ не выбран" },
	"operation": { "selectAnOperationToViewDetails": "Выберите операцию для просмотра подробностей" },
	"header": {
		"operationSettings": "Настройки операции",
		"closeClient": "Закрыть клиент"
	},
	"openApiClientButton": { "openAPIClient": "Открыть API-клиент" },
	"requestBody": {
		"noBody": "Без тела",
		"delete": "Удалить",
		"selectFile": "Выбрать файл",
		"multipartForm": "Составная форма",
		"formUrlEncoded": "Форма с URL-кодированием",
		"binaryFile": "Двоичный файл",
		"other": "Другое",
		"none": "Нет"
	},
	"requestBodyStructured": { "body": "Тело" },
	"requestBodyViewToggle": {
		"schema": "Схема",
		"form": "Форма",
		"raw": "Исходный вид",
		"fixBody": "Исправьте тело, чтобы переключиться в режим формы"
	},
	"requestCodeSnippet": {
		unavailable: "Для этого примера нет доступного образца кода.",
		"codeSnippet": "Фрагмент кода"
	},
	"requestTable": {
		"enabled": "Включено",
		"key": "Ключ",
		"value": "Значение"
	},
	"requestTableRow": {
		"key": "Ключ",
		"value": "Значение",
		"delete": "Удалить",
		"selectFile": "Выбрать файл",
		"globalCookieHint": "Глобальные cookie используются во всём рабочем пространстве. Нажмите, чтобы перейти к ним.",
		"readOnlyHint": "Это свойство доступно только для чтения. Чтобы изменить его, переопределите его или отключите с помощью флажка.",
		"include": "Включить {name} в запрос",
		"keyLabel": "Ключ для {name}",
		"valueLabel": "Значение для {name}",
		"deleteRow": "Удалить {name}",
		"row": "строку"
	},
	"requestTableTooltip": {
		"min": "мин.:",
		"max": "макс.:",
		"default": "по умолчанию:",
		"invalid": "Недопустимое значение",
		"moreInformation": "Подробнее"
	},
	"headers": {
		"headerKey": "Ключ заголовка",
		"headerValue": "Значение заголовка",
		"noHeaders": "Нет заголовков"
	},
	"responseBody": { "binaryFile": "Двоичный файл" },
	"responseBodyPreview": { "previewUnavailable": "Предпросмотр недоступен" },
	"responseBodyStreaming": {
		"body": "Тело",
		"listening": "Ожидание данных…",
		"cancel": "Отмена"
	},
	"responseBodyToggle": {
		"preview": "Предпросмотр",
		"raw": "Исходный вид"
	},
	"responseBodyVirtual": {
		"body": "Тело",
		"largeBodyHint": "Тело этого ответа слишком велико для подсветки синтаксиса."
	},
	"responseCookies": {
		"cookies": "Cookie",
		"cookieName": "Имя cookie",
		"cookieValue": "Значение cookie",
		"noCookies": "Нет cookie"
	},
	"responseEmpty": {
		"roadmap": "План развития",
		"poweredByScalarcom": "На базе Scalar.com",
		"getStarted": "Начать",
		"newRequest": "Новый запрос",
		"sendRequest": "Отправить запрос",
		"version": "Scalar App V{version} Beta"
	},
	"responseLoadingOverlay": { "cancel": "Отмена" },
	"addressBar": {
		"path": "Путь",
		"copyUrl": "Копировать URL",
		"send": "Отправить",
		"sendRequest": "Отправить запрос {method} на {url}",
		"duplicateRequest": "Запрос {method} к {path} уже существует в этом документе",
		"urlPlaceholder": "Введите URL",
		"webhookUrlPlaceholder": "Введите полный URL вебхука, например https://example.com/hook"
	},
	"addressBarHistory": { "requestHistory": "История запросов" },
	"environmentSelector": {
		"noEnvironment": "Без окружения",
		"notAvailableInThisContext": "Недоступно в этом контексте",
		"environmentHint": "Окружения позволяют управлять переменными, такими как ключи API и базовые URL, в разных контекстах.",
		"add": "Добавить окружение",
		"select": "Выбрать окружение",
		"unavailable": "{name} (Недоступно)",
		"current": "Текущее окружение: {name}"
	},
	"deleteRequestAuthModal": {
		"deleteSecurityScheme": "Удалить схему безопасности",
		"cancel": "Отмена",
		"delete": "Удалить",
		"confirmation": "Это действие нельзя отменить. Вы собираетесь удалить схему безопасности {name} из коллекции."
	},
	"oauth2": {
		deviceAuthorizationUrl: "URL авторизации устройства",
		deviceVerificationPrompt: "Откройте страницу подтверждения и введите этот код:",
		waitingForAuthorization: "Ожидание авторизации…",
		cancelDeviceAuthorization: "Отмена",
		"accessToken": "Токен доступа",
		"refreshUrl": "URL обновления",
		"refresh": "Обновить",
		"authUrl": "URL аутентификации",
		"tokenUrl": "URL токена",
		"redirectUrl": "URL перенаправления",
		"username": "Имя пользователя",
		"password": "Пароль",
		"clientID": "ID клиента",
		"clientSecret": "Секрет клиента",
		"usePKCE": "Использовать PKCE",
		"credentialsLocation": "Расположение учётных данных",
		"authorize": "Авторизовать",
		"clear": "Очистить",
		"failedToauthorize": "Ошибка авторизации",
		"failedToRefreshToken": "Не удалось обновить токен",
		"optionalRedirectUrl": "Необязательный URL перенаправления",
		"clearTokens": "Очистить токены",
		"resetDiscovery": "Сбросить обнаружение"
	},
	"oauthScopesAddModal": {
		"name": "Имя:",
		"description": "Описание:",
		"readUserData": "Чтение данных пользователя",
		"edit": "Изменить область доступа",
		"add": "Добавить область доступа",
		"save": "Сохранить",
		"required": "Необходимо указать имя области доступа.",
		"duplicate": "Область доступа с именем «{name}» уже существует."
	},
	"oauthScopesInput": {
		"noScopesDefined": "Области доступа не определены",
		"addScope": "Добавить область доступа",
		"deselectAll": "Снять выделение",
		"selectAll": "Выбрать всё",
		"selectedScopes": "Выбрано областей доступа: {count} / {total}",
		"editScope": "Изменить {name}",
		"deleteScope": "Удалить {name}",
		"selectScope": "Выбрать область доступа {name}"
	},
	"openIdConnect": {
		"discoveryUrl": "URL обнаружения",
		"fetchConfiguration": "Получить конфигурацию",
		"failedToFetchConfiguration": "Не удалось получить конфигурацию OpenID Connect"
	},
	"requestAuthDataTable": { "noauthenticationSelected": "Аутентификация не выбрана" },
	"requestAuthTab": {
		"token": "Токен",
		"bearerToken": "Токен Bearer",
		"getAToken": "Получить токен",
		"refresh": "Обновить",
		"username": "Имя пользователя",
		"password": "Пароль",
		"name": "Имя",
		"value": "Значение",
		"cancel": "Отмена",
		"authorize": "Авторизовать",
		"unsupportedCredentials": "Браузерный клиент не отправляет учётные данные для этой схемы безопасности AsyncAPI.",
		"authorizeVia": "Авторизовать через {name}",
		"unsupportedType": "Тип схемы безопасности {type} пока не поддерживается.",
		"missingType": "У схемы безопасности не указан тип. Проверьте документ {type} или конфигурацию аутентификации.",
		"failedToauthorize": "Ошибка авторизации",
		"failedToRefresh": "Не удалось обновить",
		"configure": "Настроить {name}",
		"mutualTlsHint": "Взаимная аутентификация TLS использует клиентский сертификат, передаваемый при согласовании TLS, поэтому здесь ничего вводить не нужно."
	},
	"commandActionForm": { "continue": "Продолжить" },
	"environment": {
		"thisIsTheActiveEnvironment": "Это активное окружение",
		"active": "Активно",
		"editEnvironment": "Изменить окружение",
		"deleteEnvironment": "Удалить окружение"
	},
	"environmentCreateModal": {
		"environmentName": "Название окружения",
		"thisEnvironmentNameIsAlreadyInUse": "Это название окружения уже используется.",
		"update": "Обновить окружение",
		"add": "Добавить окружение"
	},
	"environmentDeleteModal": {
		"cancel": "Отмена",
		"deleteEnvironment": "Удалить окружение",
		"deleteConfirmation": "Вы уверены, что хотите удалить это окружение? Это действие нельзя отменить.",
		"title": "Удалить {name}"
	},
	"environmentVariablesDropdown": {
		"variableSuggestions": "Предложения переменных",
		"addVariable": "Добавить переменную"
	},
	"environmentVariablesTable": {
		"name": "Имя",
		"value": "Значение",
		"actions": "Действия",
		"environmentVariableName": "Имя переменной окружения",
		"environmentVariableValue": "Значение переменной окружения"
	},
	"documentSearchModal": {
		"documentSearch": "Поиск по документу",
		"documentSearchResults": "Результаты поиска по документу",
		"navigate": "↑↓ Навигация",
		"select": "⏎ Выбрать",
		"keyboardInstructions": "Используйте стрелки вверх и вниз для навигации, Enter для выбора и вводите текст для фильтрации результатов"
	},
	"searchResult": {
		"httpMethod": "Метод HTTP:",
		"path": "Путь:",
		"description": "Описание:",
		"heading": "Заголовок",
		"operation": "Операция",
		"tag": "Тег"
	},
	"sectionFilter": {
		"all": "Все",
		"auth": "Аутентификация",
		"variables": "Переменные",
		"cookies": "Cookie",
		"headers": "Заголовки",
		"query": "Запрос",
		"body": "Тело"
	},
	"requestParams": {
		"addParameter": "Добавить параметр",
		"searchParameters": "Поиск параметров",
		"noParametersFound": "Нет подходящих параметров",
		"clearAll": "Очистить всё: {title}",
		"clear": "Очистить",
		"clearOptionalParameters": "Очистить необязательные параметры"
	},
	"responseBodyDownload": {
		"download": "Скачать тело ответа",
		"label": "Скачать",
		"body": "Тело ответа"
	},
	"responseMetaInformation": {
		"duration": "Информация об ответе, длительность:",
		"size": ", размер:",
		"status": ", статус:"
	},
	"authSelector": {
		"selectedType": "Выбранный тип аутентификации: {type}",
		"multipleTypes": "Выбрано несколько типов аутентификации",
		"selectType": "Выбрать тип аутентификации",
		"optional": "Необязательно",
		"required": "Обязательно",
		"deleteScheme": "Удалить {name}",
		"requiredGroup": "Обязательная аутентификация",
		"availableGroup": "Доступная аутентификация",
		"addGroup": "Добавить аутентификацию"
	},
	"operationBlock": {
		"webhookUrlRequired": "Необходим URL вебхука. Сначала укажите адрес назначения.",
		"pathParametersRequired": "Параметры пути должны иметь значения.",
		"forbiddenMethod": "Fetch API не может отправлять запросы {method}."
	},
	"dataTableCheckbox": { "toggle": "Переключить" },
	"pillTooltipHost": {
		"computedAtExecution": "Вычисляется при выполнении запроса",
		"noValue": "Нет значения"
	},
	"authOptions": {
		oauth2DeviceAuthorization: "Авторизация устройства OAuth2",
		"apiKeyCookie": "Ключ API в cookie",
		"apiKeyHeader": "Ключ API в заголовках",
		"apiKeyQuery": "Ключ API в параметрах запроса",
		"httpBasic": "HTTP Basic",
		"httpBearer": "HTTP Bearer",
		"oauth2Implicit": "Неявный поток OAuth2",
		"oauth2Password": "Поток OAuth2 с паролем",
		"oauth2ClientCredentials": "Учётные данные клиента OAuth2",
		"oauth2AuthorizationFlow": "Код авторизации OAuth2"
	},
	"deleteSidebarListElement": { "delete": "Удалить {name}" },
	"deleteModal": { "delete": "Удалить {name}" }
};
//#endregion
export { ru };

//# sourceMappingURL=ru.js.map